import { GET_DEVICE_DATA, GET_DEVICE_CUSTOMER_ID } from './constants'

export const setDeviceData = (deviceData) => (dispatch) => {
  dispatch({
    type: GET_DEVICE_DATA,
    payload: deviceData,
  })
}
export const setCustomerData = (customerID) => (dispatch) => {
  dispatch({
    type: GET_DEVICE_CUSTOMER_ID,
    payload: customerID,
  })
}
